<template>
  <div id="PrintTemplate">
    <section class="top-area">
      <img src="@/assets/img/print/LOGONAME.png" class="logo"/>

      <div class="personal-information">
        <div>地址：台中市西屯區文心路三段238號4樓</div>
        <div>電話：04-23149111     傳真：04-23145599</div>
        <div>客服Line：@YF42669258</div>
        <div>生命禮儀諮詢電話：0982-751-914</div>
        <div>客戶免付費服務專線：0809-001-339</div>
      </div>

      <div class="title">安家寶「{{ data.plan === 'A' ? '永保' : '長安' }}專案」互助費帳單</div>

      <table class="pay" cellspacing="0" >
        <tr align="center">
          <td bgcolor="#ffffcc">月份帳單</td>
          <td bgcolor="#ffffcc">本期應繳總額</td>
          <td bgcolor="#ffffcc">繳款截止日</td>
        </tr>
        <tr align="center">
          <td>{{ convertRocDate(data.dead_line, false, true).year }}{{ convertRocDate(data.dead_line, false, true).month }}</td>
          <td>{{ data.total }}</td>
          <td>{{ convertRocDate(data.dead_line, false) }}</td>
        </tr>
      </table>

      <div class="receive">
        <div class="address">
          <div>{{ data.pay_BpostalCode }}</div>
          <div>{{ data.pay_Baddress }}</div>
          <div>{{ data.pay_name }} 先生/小姐 收</div>
        </div>

        <div class="business">業務：{{ data.sales_number }}{{ data.sales_name }}</div>

        <div class="barcode">
          <img :id="`barCode1_${data.id}`" />

          <span>{{ this.data.number }}</span>
        </div>
      </div>

      <div class="pay-notice">
        <img src="@/assets/img/print/sweepstakes.png" />
      </div>

    </section>

    <section class="center-area">
      <div class="title">(第一聯：客戶收執聯)</div>

      <table cellspacing="0">
        <tr bgcolor="#ffffcc">
          <td align="center">要助人姓名</td>
          <td align="center">互助人姓名</td>
          <td align="center">契約單編號</td>
          <td align="center">契約生效日</td>
          <td align="center">累計已繳互助費</td>
          <td align="center">累計互助人次</td>
          <td v-if="deferredShow" align="center">遞延中人次</td>
        </tr>

        <tr>
          <td align="center">{{ data.pay_name }}</td>
          <td align="center">{{ data.member_name }}</td>
          <td align="center">{{ data.number }}</td>
          <td align="center">{{ convertRocDate(data.join_date) }}</td>
          <td align="center">${{ data.help_total }}</td>
          <td align="center">{{ data.help }}人</td>
          <td v-if="deferredShow" align="center">{{ deferred }}人</td>
        </tr>

        <tr bgcolor="#d6eaf8" align="center">
          <td>期別</td>
          <td>費用說明</td>
          <td>金額</td>
          <td :colspan="deferredShow ? 4 : 3">繳款方式說明</td>
        </tr>

        <template v-if="multipleDetails">
          <tr>
            <td align="center">{{ data.details ? data.details[0].period : '' }}</td>
            <td align="center">{{ data.details ? getBillFeeDescription(data.details[0]) : '' }}</td>
            <td align="center">{{ data.details ? data.details[0].amount : '' }}</td>
            <td valign="top" :colspan="deferredShow ? 4 : 3" rowspan="11">
              <div class="illustrate">
                <div>一、便利商店：持本帳單至超商(7-11、全家、萊爾富)繳款</div>
                <div>二、郵局繳款：持本帳單至各郵局臨櫃繳款</div>
                <div>三、台中銀行：持本帳單至各台中銀行臨櫃繳款</div>
                <div>四、查詢身故互助名單,詳見永豐官網</div>
                <div class="notice">提醒您!!要助人若連續兩次逾期繳費,經雙掛號催繳仍未全額繳納者,視為終止契約,契約一旦終止後,不得請求返還已繳交之任何費用。</div>
              </div>
            </td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[1] ? data.details[1].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[1] ? getBillFeeDescription(data.details[1]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[1] ? data.details[1].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[2] ? data.details[2].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[2] ? getBillFeeDescription(data.details[2]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[2] ? data.details[2].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[3] ? data.details[3].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[3] ? getBillFeeDescription(data.details[3]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[3] ? data.details[3].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[4] ? data.details[4].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[4] ? getBillFeeDescription(data.details[4]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[4] ? data.details[4].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[5] ? data.details[5].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[5] ? getBillFeeDescription(data.details[5]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[5] ? data.details[5].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[6] ? data.details[6].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[6] ? getBillFeeDescription(data.details[6]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[6] ? data.details[6].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[7] ? data.details[7].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[7] ? getBillFeeDescription(data.details[7]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[7] ? data.details[7].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[8] ? data.details[8].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[8] ? getBillFeeDescription(data.details[8]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[8] ? data.details[8].amount : '' : '' }}</td>
          </tr>

          <tr>
            <td align="center">{{ data.details ? data.details[9] ? data.details[9].period : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[9] ? getBillFeeDescription(data.details[9]) : '' : '' }}</td>
            <td align="center">{{ data.details ? data.details[9] ? data.details[9].amount : '' : '' }}</td>
          </tr>
        </template>

        <template v-else>
          <tr>
            <td align="center">{{ data.period }}</td>
            <td align="center">{{ getBillFeeDescription(data) }}</td>
            <td align="center">{{ data.amount }}</td>
            <td valign="top" :colspan="deferredShow ? 4 : 3" rowspan="11">
              <div class="illustrate">
                <div>一、便利商店:持本帳單至超商(7-11、全家、萊爾富)繳款</div>
                <div>二、郵局繳款:持本帳單至各郵局臨櫃繳款</div>
                <div>三、台中銀行:持本帳單至各台中銀行臨櫃繳款</div>
                <div>四、查詢身故互助名單,詳見永豐官網</div>
                <div class="notice">提醒您!!要助人若連續兩次逾期繳費,經雙掛號催繳仍未全額繳納者,視為終止契約,契約一旦終止後,不得請求返還已繳交之任何費用。</div>
              </div>
            </td>
          </tr>

          <!-- <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->
        </template>

        <tr>
          <td align="right" bgcolor="#d6eaf8" colspan="3">合計新台幣：{{ data.total }}元整</td>
        </tr>

        <tr>
          <td :colspan="deferredShow ? 7 : 6">上月身故人數：{{ data.dead_count ? data.dead_count : 12 }}人</td>
        </tr>
      </table>

      <img src="@/assets/img/print/cut.gif" class="cut"/>
    </section>

    <section class="bottom-area">
      <div class="title">(第二聯：代收存款憑條）</div>

      <table cellpadding="0" border='0'>
        <tr bgcolor="#d6eaf8">
          <td colspan="3" align="center">郵政劃撥 收款專戶</td>
        </tr>
        <tr>
          <td class="pl-20" width="41%">戶名：永豐網路平台股份有限公司(22805347)</td>
          <td width="14%" align="right">劃撥帳號</td>
          <td width="45%" align="center" class="barCode barCode2">
            <img :id="`barCode2_${data.id}`" />

            <span>{{ this.data.barCode2 }}</span>
          </td>
        </tr>
        <tr>
          <td class="pl-20" width="40%">寄款人代號：({{ data.barCode3 }})</td>
          <td width="15%" align="right">寄款人代號</td>
          <td width="45%" align="center" class="barCode barCode3">
            <img :id="`barCode3_${data.id}`" />

            <span>{{ this.data.barCode3 }}</span>
          </td>
        </tr>
        <tr>
          <td class="pl-20" width="45%">繳費金額: 新台幣{{ convertToChineseNumeral(data.total) }}({{ data.total }})</td>
          <td width="10%" align="right">金額</td>
          <td width="45%" align="center" class="barCode barCode4">
            <img :id="`barCode4_${data.id}`" />

            <span>{{ this.data.barCode4 }}</span>
          </td>
        </tr>
      </table>

      <table class="center" cellpadding="0" border='0'>
        <tr bgcolor="#d6eaf8">
          <td width="50%" align="center">台中銀行收款專戶</td>

          <td width="50%" class="left-border" align="center">便利商店繳款條碼區(7-11、全家、萊爾富)</td>
        </tr>

        <tr>
          <td width="50%" class="store-barcode">
            <div class="barcode-item c-gap-20">
              <div>虛擬帳號</div>
              <div class="barCode barCode8">
                <img :id="`barCode8_${data.id}`" />

                <span>{{ this.data.virtual_account }}</span>
              </div>

              <div>金額</div>
              <div class="barCode barCode9">
                <img :id="`barCode9_${data.id}`" />

                <span>{{ this.data.barCode4 }}</span>
              </div>
            </div>
          </td>

          <td width="50%" class="store-barcode left-border">
            <div class="barcode-item">
              <div>條碼一</div>
              <div class="barCode barCode5">
                <img :id="`barCode5_${data.id}`" />

                <span>{{ this.data.barCode5 }}</span>
              </div>

              <div>條碼二</div>
              <div class="barCode barCode6">
                <img :id="`barCode6_${data.id}`" />

                <span>{{ this.data.barCode6 }}</span>
              </div>

              <div>條碼三</div>
              <div class="barCode barCode7">
                <img :id="`barCode7_${data.id}`" />

                <span>{{ this.data.barCode7 }}</span>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <table class="last" cellpadding="0" border='0'>
        <tr>
          <td width="10%" class="text-vertical" valign="center" align="center">認<br/>証<br/>欄</td>
          <td width="90%" class="left-border"></td>
          <!-- <td width="50%" class="store-barcode">
            <div>便利商店繳款條碼區(7-11、全家、萊爾富)</div>

            <div class="barcode-item">
              <div>條碼一</div>
              <div class="barCode barCode5">
                <img :id="`barCode5_${data.id}`" />

                <span>{{ this.data.barCode5 }}</span>
              </div>

              <div>條碼二</div>
              <div class="barCode barCode6">
                <img :id="`barCode6_${data.id}`" />

                <span>{{ this.data.barCode6 }}</span>
              </div>

              <div>條碼三</div>
              <div class="barCode barCode7">
                <img :id="`barCode7_${data.id}`" />

                <span>{{ this.data.barCode7 }}</span>
              </div>
            </div>
          </td> -->
        </tr>
        <tr>
          <td colspan="3">帳單期別：{{ convertRocDate(data.dead_line, false, true).year }}{{ convertRocDate(data.dead_line, false, true).month }} {{ data.number }} {{ data.member_name }}</td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
import jsbarcode from 'jsbarcode';
import { convertRocDate, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'PrintTemplate',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
    multipleDetails: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    deferred() {
      const reference = new Date('2023-01-01'); // 2023年初日期
      const target = new Date(this.data.join_date); // 入會日期

      return reference <= target ? 0 : this.data.deferred;
    },
    deferredShow() {
      // const reference = new Date('2023-01-01'); // 2023年初日期
      // const target = new Date(this.data.join_date); // 入會日期

      // return reference <= target ? false : true;

      return false;
    }
  },
  mounted() {
  //  window.print();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.$nextTick(() => {
        this.generateBarcode();
      });
    },
    convertRocDate,
    getBillFeeDescription,
    generateBarcode() {
      jsbarcode(`#barCode1_${this.data.id}`, this.data.number, {
        format: "CODE39",
        // width: 1,
        // height: 30,
        // fontSize: 14,
        marginBottom: 5,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode2_${this.data.id}`, this.data.barCode2, {
        format: "CODE39",
        // width: 1.5,
        // height: 25,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode3_${this.data.id}`, this.data.barCode3, {
        format: "CODE39",
        // width: 1,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode4_${this.data.id}`, this.data.barCode4, {
        format: "CODE39",
        // width: 2,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        // font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode5_${this.data.id}`, this.data.barCode5, {
        format: "CODE39",
        // width: 1,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode6_${this.data.id}`, this.data.barCode6, {
        format: "CODE39",
        // width: 1,
        // height: 25,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode7_${this.data.id}`, this.data.barCode7, {
        format: "CODE39",
        // width: 1,
        // height: 15,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode8_${this.data.id}`, this.data.virtual_account, {
        format: "CODE39",
        // width: 1,
        // height: 15,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode9_${this.data.id}`, this.data.barCode4, {
        format: "CODE39",
        // width: 2,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        // font: "DFKai-sb",
        displayValue: false
      });
    },
    convertToChineseNumeral(n) {
      const fraction = ['角', '分'];
      const digit = [
          '零', '壹', '貳', '叁', '肆',
          '伍', '陸', '柒', '捌', '玖'
      ];
      const unit = [
        ['元', '萬', '億'],
        ['', '拾', '佰', '仟']
      ];
      const head = n < 0 ? '欠' : '';
      n = Math.abs(n);
      let s = '';
      for (var i = 0; i < fraction.length; i++) {
          s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
      }
      s = s || '整';
      n = Math.floor(n);
      for (var i = 0; i < unit[0].length && n > 0; i++) {
          var p = '';
          for (var j = 0; j < unit[1].length && n > 0; j++) {
              p = digit[n % 10] + unit[1][j] + p;
              n = Math.floor(n / 10);
          }
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
      }
      return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
    }
  }
}
</script>

<style lang="scss" scoped>
@media print {
  @page {
    margin: 20cm;
    size: A4 portrait;
  }
}
* {
  font-family: DFKai-sb;
}

#PrintTemplate {
  width: 794px;
  height: 1193px;
  .top-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 5px;
    height: auto;
    width: 100%;
    font-size: 18px;
    .logo {
      height: 90px;
      width: 380px;
    }
    .personal-information {
      margin-left: 20px;
      font-weight: bold;
    }
    .title {
      font-size: 26px;
      font-weight: bold;
    }
    table.pay {
      width: 100%;
      table-layout: fixed;
      border: 1px solid #000000;
      tr {
        td {
          height: 21px;
          border: 1px solid #000000;
          font-size: 18px;
          line-height: 1;
        }
      }
    }
    .receive {
      font-weight: bold;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      row-gap: 10px;
      // margin-top: 10px;
      padding: 0 15px 0 15px;
      .address {
        font-size: 20px;
      }
      .business {
        font-size: 18px;
      }
      .barcode {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        img {
          width: 212px;
          height: 50px;
        }
      }
    }
    .pay-notice {
      margin-top: 10px;
      height: 210px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .center-area {
    width: 100%;
    .title {
      text-align: right;
    }
    table {
      width: 100%;
      table-layout: fixed;
      word-wrap: break-word;
      word-break: normal;
      font-weight: lighter;
      font-size: 18px;
      line-height: 1;
      border: 1px solid #000000;
      text-align: justify;
      tr {
        td {
          border: 1px solid #000000;
          height: 21px;
          .illustrate {
            line-height: 1.5;
            .notice {
              color: red;
              // margin-top: 5px;
            }
          }
        }
      }
    }
    img.cut {
      width: 97%;
      // margin: 5px 0 5px 0;
    }
  }
  .bottom-area {
    width: 100%;
    .title {
      text-align: right;
    }
    table {
      width: 100%;
      font-weight: bold;
      font-size: 16px;
      line-height: 1;
      border: 1px solid #000000;
      tr:first-child {
        border: 1px solid #000000;
      }
      tr {
        td {
          // height: 21px;
          &.pl-20 {
            padding-left: 20px;
          }
          &.barCode {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 14px;
            width: 100%;
            &.barCode2 {
              img {
                width: 240px;
                height: 30px;
              }
            }
            &.barCode3 {
              img {
                width: 288px;
                height: 25px;
              }
            }
            &.barCode4 {
              img {
                width: 192px;
                height: 35px;
              }
            }
          }
        }
      }
    }
    table.center {
      tr {
        border-top: 0;
        td {
          &.left-border {
            border-left: 1px solid #000000;
          }
          &.text-vertical {
            border-right: 1px solid #000000;
          }
          &.store-barcode {
           .barcode-item {
              display: grid;
              grid-template-columns: 1fr 1fr;
              column-gap: 10px;
              align-items: center;
              padding: 5px 20px 5px 10px;
              text-align: center;
              &.c-gap-20 {
                row-gap: 20px;
              }
              .barCode {
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 14px;
                width: 100%;
                &.barCode5 {
                  img {
                    width: 176px;
                    height: 25px;
                  }
                }
                &.barCode6 {
                  img {
                    width: 288px;
                    height: 30px;
                  }
                }
                &.barCode7 {
                  img {
                    width: 272px;
                    height: 20px;
                  }
                }
                &.barCode9 {
                  img {
                    width: 192px;
                    height: 35px;
                  }
                }
                &.barCode8 {
                  img {
                    width: 288px;
                    height: 25px;
                  }
                }
              }
           }
          }
        }
      }
    }
    table.last {
      height: 80px;
      tr {
        border-top: 0;
        td {
          &.left-border {
            border-left: 1px solid #000000;
          }
        }
      }
    }
    // table.center {
    //   border-top: 0;
    //   tr {
    //     td {
    //       // border: 1px solid #000000;
    //     }
    //   }
    //   tr:first-child {
    //     border-top: 0;
    //     td {
    //       // border: 0;
    //       &.text-vertical {
    //         border-right: 1px solid #000000;
    //       }
    //       &.store-barcode {
    //         text-align: center;
    //         border-left: 1px solid #000000;
    //         > div:first-child {
    //           background: #d6eaf8;
    //           border-bottom: 1px solid #000000;
    //         }
    //        .barcode-item {
    //           display: grid;
    //           grid-template-columns: 1fr 1fr;
    //           column-gap: 10px;
    //           padding: 5px 20px 5px 10px;
    //           text-align: center;
    //           .barCode {
    //             display: flex;
    //             flex-direction: column;
    //             align-items: center;
    //             font-size: 14px;
    //             width: 100%;
    //             &.barCode5 {
    //               img {
    //                 width: 176px;
    //                 height: 25px;
    //               }
    //             }
    //             &.barCode6 {
    //               img {
    //                 width: 288px;
    //                 height: 30px;
    //               }
    //             }
    //             &.barCode7 {
    //               img {
    //                 width: 272px;
    //                 height: 20px;
    //               }
    //             }
    //           }
    //        }
    //       }
    //     }
    //   }
    // }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/Bill.vue